import React, { FC } from 'react';
import { MaterialSymbol } from '@/components/MaterialSymbol';
import DeleteButton from '@/components/DeleteButton';
import EditorSectionActionButton, {
  EditorSectionActionButtonProps,
} from '../../../lib/components/EditorSectionActionButton';
import Container from '../../../../components/Container';

export const AttachmentsBlockActions: FC<Pick<EditorSectionActionButtonProps, 'onDelete' | 'onDuplicate'>> = ({
  onDuplicate,
  onDelete,
}) => {
  return (
    <Container right>
      <DeleteButton
        onConfirm={onDelete ?? (() => null)}
        component='IconButton'
        deleteIcon={<MaterialSymbol name='do_not_disturb_on' />}
      />
    </Container>
  );
};

export default AttachmentsBlockActions;
